module.exports = __webpack_public_path__ + "static/media/favicon-g-encontros.ccd2735e.ico";